import { JsonObject, JsonProperty } from 'json2typescript';

import { Authority } from './authority';

/**
 * è´¦å·ä¿¡æ¯, åºäºåå°spring securityç¸å³æ åçæ°æ®ç»æ
 */
@JsonObject
export class Account {
  /**
   * è´¦å·æ¯å¦è¿æ
   */
  @JsonProperty('accountNonExpired', Boolean)
  accountNonExpired: boolean = undefined;

  /**
   * è´¦å·æ¯å¦è¢«éå®
   */
  @JsonProperty('accountNonLocked', Boolean)
  accountNonLocked: boolean = undefined;

  /**
   * è´¦å·ææ¥æçè§è²åè¡¨
   */
  @JsonProperty('authorities', [String])
  authorities: Authority[] = undefined;

  /**
   * è´¦å·èµæ ¼æ¯å¦è¿æ
   */
  @JsonProperty('credentialsNonExpired', Boolean)
  credentialsNonExpired: boolean = undefined;

  /**
   * è´¦å·ç¶ææ¯å¦æ­£å¸¸(false = æ³¨éç¶æ)
   */
  @JsonProperty('enabled', Boolean)
  enabled: boolean = undefined;

  /**
   * è´¦å·Id
   */
  @JsonProperty('id', Number)
  id: number = undefined;

  /**
   * ç¨æ·å
   */
  @JsonProperty('username', String)
  username: string = undefined;
}
